import React from "react";
import { Button, Modal } from "antd";
import { FiAlertCircle } from "react-icons/fi";

interface Props {
    open: boolean;
    onClose: () => void;
}

const AlreadLogoutModal = ({ open, onClose }: Props) => {
    return (
        <Modal
            title={null}
            open={open}
            cancelButtonProps={{ style: { display: 'none' } }}
            closable={false}
            maskClosable={false}
            footer={null}
            width={420}
        >
            <div className="flex flex-col justify-center gap-4 px-4 pt-2">
                <h3 className="flex items-center gap-2 text-lg font-semibold text-gray-500">
                    <FiAlertCircle className="text-orange-500" size={20} />
                    <span>Session Expired</span>
                </h3>
                <p>Your session has ended. You will be redirected to the login page.</p>

                <div className="flex justify-end">
                    <Button type="primary" onClick={() => {
                        onClose();
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.replace('/signin');
                    }}>
                        OK
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default AlreadLogoutModal